export enum ScreenTransitionDirection {
  Left,
  Right,
}
